import { render, staticRenderFns } from "./AthleteProfile.vue?vue&type=template&id=80eb5214&scoped=true&"
import script from "./AthleteProfile.vue?vue&type=script&lang=ts&"
export * from "./AthleteProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteProfile.vue?vue&type=style&index=0&id=80eb5214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80eb5214",
  null
  
)

export default component.exports